import { Surface } from '../../../../specification/Surface';

export const getRatioRbsToCbs = (cuttedBuiltSurface: Surface, realBuiltSuface: Surface) =>
  cuttedBuiltSurface.value !== 0 && realBuiltSuface.value !== 0
    ? cuttedBuiltSurface.value / realBuiltSuface.value
    : 0;
